import { Size } from '../utils/UNSAFE_size';

export const emptyKeys = { all: false, keys: new Set() };
export type GutterSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

/**
 * A mapping of gutterSize to concrete size in pixels
 */
export const gutterSizeToPX: Record<string, number> = {
  xs: 12,
  sm: 16,
  md: 24,
  lg: 48,
  xl: 64
};

export const getGapSize = (gutterSize?: GutterSize) => {
  const px = gutterSizeToPX[gutterSize || 'sm'];
  const gap = `${px / 4}x` as Size;
  return gap;
};

export const getColCount = (gapWidth: number, cardWidth?: number, rootWidth?: number) => {
  if (!cardWidth || !rootWidth) return 0;

  // if we have n cards, we have n-1 gaps
  const colCount = Math.floor((rootWidth + gapWidth) / (gapWidth + cardWidth));
  return Math.max(1, colCount);
};
